// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

// Import configuration from .json file
import config from '../../../configs/config.json';
const AUTH_URL = config.AUTH_URL;
const ADMIN_AUTH_URL = AUTH_URL + '/admin';


const TOKEN_EXPIRATION = 7; // 1 week


// Create the login box component
class LoginBox extends React.Component {
    constructor(props) {
        super(props);

        // State stores user and page information
        this.state = {
            credentials: {
                email: '',
                password: ''
            },
            showPassword: false,
            invalidEmail: false,
            invalidPassword: false,
            message: '',
            success: false
        }
    }

    componentDidMount = () => {
        document.addEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            // When the [ENTER] key is pressed, fire off the back-end auth call
            this.submitLogin();
        }
    }

    handleChange = (field) => (event) => {
        // When a textbox is updated, update the state
        var credentials = this.state.credentials;
        credentials[field] = event.target.value;
        this.setState({ credentials: credentials });
    }

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    emailIsValid = () => {
        // Verify the email entered is valid
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.credentials.email);
    }

    resendEmailVerification = () => {
        console.log("HELP: ", this.state.credentials.email);
        axios.post(`${AUTH_URL}/verify/resend`, { email: this.state.credentials.email })
            .then(response => {
                var payload = response.data;
                console.log(payload);
                if (payload.success) {
                    this.setState({ message: `Resent email verification to ${this.state.email}. Please check your inbox and follow email verification instructions.` })
                } else {
                    this.setState({ message: `Unable to send email verification. Please try again.` });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ message: `Unable to send email verification. Please try again.` });
            })
    }

    submitLogin = () => {
        // When the user submits their login credentials, send the credentials to the back-end server for verification

        var self = this;

        if (this.state.credentials.email === '' && this.state.credentials.password === '') {
            // Blank credentials
            this.setState({ invalidEmail: true, invalidPassword: true, message: 'Enter your email and password.' });
        } else if (!this.emailIsValid()) {
            // Email address is not valid
            this.setState({ invalidEmail: true, message: 'Enter a correct email address.' });
        } else if (this.state.credentials.password === '') {
            // Missing password
            this.setState({ invalidPassword: true, message: 'Enter your password.' });
        } else {
            // Proper credentials entered
            this.setState({ invalidEmail: false, invalidPassword: false, message: '' })


            if (this.props.type === 'member') {
                // Query back-end to see if the credentials entered are of a valid member
                axios.post(`${AUTH_URL}/login`, { password: this.state.credentials.password, email: this.state.credentials.email })
                    .then(result => {
                        console.log(result);
                        if (result.data.invalidEmail) {
                            self.setState({ message: 'Email account does not exist.' });
                        } else if (result.data.invalidPassword) {
                            var credentials = this.state.credentials;
                            credentials.password = '';
                            self.setState({ message: 'Incorrect password.', invalidPassword: true, credentials });
                        } else if (result.data.success) {
                            // The credentials were verified by back-end
                            // console.log('success');
                            let member = result.data.member;
                            // console.log('MEMBER: ', member);
                            self.setState({ invalidEmail: false, invalidPassword: false });

                            if (member.allowed) {
                                // The member is allowed to view videos
                                console.log(result.data)
                                let memberName = result.data.member.name;
                                let token = result.data.token;


                                // console.log('token: ', token);
                                cookie.set('token', token, { path: "/", expires: TOKEN_EXPIRATION }); // Store the cookie and allow usage on any page for 1 week
                                cookie.set('user-type', 'member', { path: "/", expires: TOKEN_EXPIRATION }); // Set the user-type to 'member'
                                cookie.set('user-name', memberName, { path: "/", expires: TOKEN_EXPIRATION });

                                // Dispay a welcome page while the user is being re-directed
                                self.setState({ success: true, message: `Welcome back, ${memberName}!` });

                                window.location.href = '/videos';


                            } else {
                                // The member is not allowed to view videos
                                var message = <span>I’m sorry, it doesn’t look like you are a current OLLI at UCI member.  Please click <a href="https://ce.uci.edu/olli/login.aspx">here</a>  to log into your account and re-enroll, or contact DCE Student Services at (949) 824-5414, Monday through Friday, 9:00am-4:00pm (Pacific).  Thank you.</span>
                                self.setState({ success: false, message: message });
                            }
                        }
                        else {
                            if (result.data.accountLocked) {
                                // var newMessage = `Your account is locked. Please try again in ${result.data.remainingTime} minutes.`;
                                self.setState({ message: `Your account is locked. Please try again in ${result.data.remainingTime} minutes.` });
                            } else {
                                let message = <div className='text-center'>Please check you email and follow one-time verify instructions before you login.<br /><button className='btn btn-primary text-center' onClick={this.resendEmailVerification}>Resend Email</button></div>
                                self.setState({ message });
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        self.setState({ success: false, message: 'Server error' });
                    })
            } else if (this.props.type === 'admin') {
                // Query back-end to see if the credentials entered are of a valid OLLI administrator
                axios.post(`${ADMIN_AUTH_URL}/login`, { password: this.state.credentials.password, email: this.state.credentials.email })
                    .then(response => {
                        console.log(response.data);
                        if (response.data.success) {
                            console.log('success');
                            self.setState({ success: true, invalidEmail: false, invalidPassword: false, message: 'Welcome back!' });
                            var token = response.data.token;
                            cookie.set('token', token, { path: "/", expires: TOKEN_EXPIRATION });
                            cookie.set('user-type', 'admin', { path: "/", expires: TOKEN_EXPIRATION });
                            cookie.set('user-name', response.data.admin.name, { path: "/", expires: TOKEN_EXPIRATION });
                            window.location.href = '/admin/history';

                        } else {
                            console.log('Invalid login');
                            self.setState({ message: 'Invalid username or password.' });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        self.setState({ success: false, message: 'Server error' });
                    })
            }

        }
    }

    // Called everytime state is changed
    render() {
        return (
            <div className='container'>
                <div className='card'>
                    <div className='card-body'>
                        <h2 style={{ textAlign: 'center', color: 'black', fontSize: 24, fontWeight: 'bold' }} className='card-title'>Welcome Back!</h2>
                        <label htmlFor='#emailInput'>Email</label>
                        <input id='emailInput' className={(this.state.invalidEmail) ? 'form-control is-invalid' : 'form-control'} type='text' placeholder='Email' value={this.state.credentials.email} onChange={this.handleChange('email')} />

                        <label htmlFor='#passwordInput' style={{ marginTop: 15 }}>Video Password</label>&nbsp;
                        {(this.state.showPassword) ?
                            <FaEyeSlash title='Hide password' size='1.5em' onClick={this.toggleShowPassword} />
                            :
                            <FaEye title='Show password' size='1.5em' onClick={this.toggleShowPassword} />
                        }
                        <input id='passwordInput' className={(this.state.invalidPassword) ? 'form-control is-invalid' : 'form-control'} type={(this.state.showPassword) ? 'text' : 'password'} placeholder='Video Password' value={this.state.credentials.password} onChange={this.handleChange('password')} />



                        {(this.state.message) ? <div style={{ marginTop: 15 }} className={(this.state.success) ? 'alert alert-success' : 'alert alert-danger'}><p>{this.state.message}</p></div> : ''}

                        <div style={{ marginTop: 15, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            {(this.props.type === 'member') ? <button className='btn btn-secondary' onClick={() => window.location.href = '/forgot'}>Reset Password</button> : ''}
                            <button className='btn btn-primary' style={{ marginLeft: '1.5rem' }} onClick={this.submitLogin}>Login</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoginBox;
